module.exports = __webpack_public_path__ + "media/images/teste-8d149c2cb23f8b0e418d7a13daeca846.png";